import { useQuery } from "@tanstack/react-query"
import { getDealEmailAttachments } from "@/api/emails"
import { EmailAttachment } from "@/types"

export const useDealEmailAttachments = (graphMessageId: string | null) => {
  return useQuery<EmailAttachment[]>({
    queryKey: ["dealEmailAttachments", graphMessageId],
    queryFn: () => getDealEmailAttachments(graphMessageId!),
    enabled: !!graphMessageId,
    staleTime: 1000 * 60 * 10,
  })
}
